import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Romper Patrones Repetitivos** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a identificar y liberarse de un ciclo o situación que se repite una y otra vez en su vida, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **El patrón que se repite (cuál es el patrón o situación que se repite una y otra vez; patrón identificado):** ${cardLabel(
        cards[0]
    )}, **Origen del patrón (de dónde viene: infancia, familia, vidas pasadas, experiencias; raíz):** ${cardLabel(
        cards[1]
    )}, **Cómo se manifiesta actualmente (de qué forma está apareciendo este patrón en su vida hoy; manifestación actual):** ${cardLabel(
        cards[2]
    )}, **Qué le está dando este patrón / beneficio secundario (qué gana, aunque sea doloroso, al mantener este patrón; beneficio oculto):** ${cardLabel(
        cards[3]
    )}, **Qué le está costando este patrón (qué le está quitando o dañando este ciclo repetitivo; costo real):** ${cardLabel(
        cards[4]
    )}, **La lección del alma detrás del patrón (qué quiere enseñarle su alma a través de este patrón; lección espiritual):** ${cardLabel(
        cards[5]
    )}, **Qué necesita soltar (qué creencia, emoción o comportamiento debe soltar; liberación):** ${cardLabel(
        cards[6]
    )}, **Nueva energía o comportamiento a incorporar (qué nueva forma de actuar o de ser necesita adoptar; nueva energía):** ${cardLabel(
        cards[7]
    )}, **Acción concreta para romper el patrón (qué puede hacer de forma práctica para empezar a salir del ciclo; paso accionable):** ${cardLabel(
        cards[8]
    )} y **Energía que se abre al romper el patrón (qué cambia o qué se libera cuando sale de este patrón; resultado / recompensa):** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Teje una lectura coherente sobre el ciclo repetitivo: conecta el patrón con su origen, su manifestación actual, el beneficio oculto que lo sostiene y el costo real que paga por mantenerlo. Ayuda a comprender la lección del alma, qué debe soltar, qué nueva energía incorporar y qué paso concreto puede dar ahora. Cierra mostrando qué se abre o se libera al romper el patrón. Detecta creencias, emociones y comportamientos que perpetúan el ciclo. Mantén un tono profesional, empático, claro y comprensible, sin juzgar. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
